import { yupToFormErrors } from 'formik';

import { LUCKY, VOICE_COLORS } from '../editor-ui/constants';

export function getId() {
  return Date.now().toString(36) + Math.floor(Math.pow(10, 12) + Math.random() * 9 * Math.pow(10, 12)).toString(36);
}

export function shuffle(array) {
  for (let i = array.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));

    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

export function getVoice(voice, voices) {
  if (voice === LUCKY) {
    const voicesNames = voices.filter((v) => v.enabled === true).map((v) => v.name);
    if (voicesNames.length === 0) {
      throw new Error('No enabled voices available');
    }
    shuffle(voicesNames);
    return voicesNames[0];
  }
  return voice;
}

export function getValidationErrors(schema, value) {
  let errors;
  try {
    schema.validateSync(value, { abortEarly: false });
  } catch (yupErrors) {
    errors = yupToFormErrors(yupErrors);
  }
  return errors;
}

export async function throttleAsync(promises, batchSize) {
  let result = [];

  for (let i = 0; i < promises.length; i += batchSize) {
    const batch = promises.slice(i, i + batchSize);
    let batchResult = await Promise.all(batch.map((p) => p));
    result.push(...batchResult);
  }

  return result;
}

export function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const onResolve = async () => {
      if (img.decode !== undefined) {
        await img.decode();
      }
      resolve(img.src);
    };
    const onReject = () => {
      reject(new Error('An Error occurred while trying to download an image'));
    };
    img.onload = onResolve;
    img.onerror = onReject;
    img.src = src;
  });
}

export function getNextVoiceColor(usedColors) {
  const firstNotUsed = VOICE_COLORS.find((c) => !usedColors.includes(c));
  if (firstNotUsed) return firstNotUsed;
  return VOICE_COLORS[usedColors.length % VOICE_COLORS.length];
}

export function goodContrastWithWhite(rgbColor) {
  const [r, g, b] = rgbColor.split(' ').map(Number);

  // Calculate relative luminance
  const luminance = [r, g, b].map((v) => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  });
  const bgLum = 0.2126 * luminance[0] + 0.7152 * luminance[1] + 0.0722 * luminance[2];

  const contrastWhite = 1.05 / (bgLum + 0.05);

  if (contrastWhite >= 1.7) return true;
  return false;
}

export async function withRetry(fn, maxAttempts = 3) {
  let attempt = 0;
  let lastError;

  while (attempt < maxAttempts) {
    try {
      return await fn();
    } catch (err) {
      lastError = err;
      attempt++;
    }
  }

  throw lastError;
}

export function formatChecksForAI(check) {
  if (check.condition === 'pass') {
    return {
      id: check.id,
      name: check.name,
      definition: `Content will pass this check if ${check.definition}`,
      pass_example: check.example,
    };
  } else {
    return {
      id: check.id,
      name: check.name,
      definition: `Content will fail this check if ${check.definition}`,
      fail_example: check.example,
    };
  }
}
